import { atom } from 'jotai';

export interface UndoToastData {
  id: string;
  taskId: string;
  taskTitle: string;
  isCompleted: boolean;
  previousState: boolean;
  timestamp: number;
}

// 当前显示的撤销 toast
export const undoToastAtom = atom<UndoToastData | null>(null);

// 显示撤销 toast 的 action atom
export const showUndoToastAtom = atom(
  null,
  (get, set, data: Omit<UndoToastData, 'id' | 'timestamp'>) => {
    const id = Math.random().toString(36).substring(2, 9);
    const toastData: UndoToastData = {
      ...data,
      id,
      timestamp: Date.now()
    };
    
    set(undoToastAtom, toastData);
  }
);

// 隐藏撤销 toast 的 action atom
export const hideUndoToastAtom = atom(
  null,
  (get, set) => {
    set(undoToastAtom, null);
  }
);

// 执行撤销操作的 action atom
export const executeUndoAtom = atom(
  null,
  (get, set, onUndo: (taskId: string, previousState: boolean) => void) => {
    const toastData = get(undoToastAtom);
    if (toastData) {
      onUndo(toastData.taskId, toastData.previousState);
      set(undoToastAtom, null);
    }
  }
);
